import { HttpClient } from '../../httpClient'
import { IPositionRole } from './interfaces.ts'
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils.ts'

export const getRoles = async (client: HttpClient): Promise<IPositionRole[]> => {
	const response = await client.get<IPositionRole[]>('/api/v2/roles')

	await validateHttpResponse(response)
	throwIfNotAllowedContentType(response, ['application/json'])

	return response.data
}
